module.exports = __webpack_public_path__ + "static/1-601dfdbac0593e1d7556756215f8af95.png";